
export const BRAND_ROUTE_INDEX_REQUEST = 'BRAND_ROUTE_INDEX_REQUEST';
export const BRAND_ROUTE_INDEX_SUCCESS = 'BRAND_ROUTE_INDEX_SUCCESS';
export const BRAND_ROUTE_INDEX_ERROR = 'BRAND_ROUTE_INDEX_ERROR';

export const BRAND_ROUTE_CREATE_REQUEST = 'BRAND_ROUTE_CREATE_REQUEST';
export const BRAND_ROUTE_CREATE_SUCCESS = 'BRAND_ROUTE_CREATE_SUCCESS';
export const BRAND_ROUTE_CREATE_ERROR = 'BRAND_ROUTE_CREATE_ERROR';

export const BRAND_ROUTE_UPDATE_REQUEST = 'BRAND_ROUTE_UPDATE_REQUEST';
export const BRAND_ROUTE_UPDATE_SUCCESS = 'BRAND_ROUTE_UPDATE_SUCCESS';
export const BRAND_ROUTE_UPDATE_ERROR = 'BRAND_ROUTE_UPDATE_ERROR';

export const BRAND_ROUTE_DELETE_REQUEST = 'BRAND_ROUTE_DELETE_REQUEST';
export const BRAND_ROUTE_DELETE_SUCCESS = 'BRAND_ROUTE_DELETE_SUCCESS';
export const BRAND_ROUTE_DELETE_ERROR = 'BRAND_ROUTE_DELETE_ERROR';
